import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CHECKOUT_URL } from '../data/content';
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const anchor = document.getElementById('hero-cta');
    if (!anchor) return;
    const observer = new IntersectionObserver(([entry]) => {
      setVisible(entry.boundingClientRect.top < 0 && !entry.isIntersecting);
    }, {
      threshold: 0
    });
    observer.observe(anchor);
    return () => observer.disconnect();
  }, []);
  return <AnimatePresence data-id="element-30" data-mp="2fuehcv8zn06y">
      {visible ? <motion.div initial={{
      y: 90,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 90,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 26
    }} className="fixed bottom-0 inset-x-0 z-40 px-3 pb-3 pt-2 bg-gradient-to-t from-navy-deep/95 to-navy-deep/70 backdrop-blur-sm" data-id="element-31" data-mp="2ftd18cd47nid">
          <a href={CHECKOUT_URL} className="flex w-full max-w-xl mx-auto items-center justify-center rounded-xl bg-brandred px-4 py-3.5 text-center text-sm sm:text-base font-extrabold uppercase tracking-wide text-white shadow-xl transition-colors hover:bg-brandred-dark" data-id="element-32" data-mp="2z27hwiv1ewmo">
            Quiero mi Ruta Hipertensión · $14
          </a>
          <p className="mt-1.5 text-center text-[10px] uppercase tracking-widest text-white/70" data-id="element-33" data-mp="2u94ny9mcll5y">
            Acceso inmediato · Pago único · Garantía 7 días
          </p>
        </motion.div> : null}
    </AnimatePresence>;
}